$('.valores__bloco').on("mouseenter", function () {
    $(this).children("p:first").css('display', 'none');
    $(this).children("p:last").css('display', 'block');
});
$('.valores__bloco').on("mouseleave", function () {
    $(this).children("p:last").css('display', 'none');
    $(this).children("p:first").css('display', 'block');
});